import { render, staticRenderFns } from "./CookiePopUp.vue?vue&type=template&id=a9232fc4&"
import script from "./CookiePopUp.vue?vue&type=script&lang=js&"
export * from "./CookiePopUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports